<script setup>
import StopWebsiteCancellationModal from "@/components/website/Modals/StopWebsiteCancellationModal.vue";
import {ref} from "vue";
import axios from "axios";
import Swal from 'sweetalert2';

const showModal = ref(false);

const props = defineProps({
  endDate: {
    required: true,
    type: String,
  },
  websiteId: {
    required: true,
    type: String,
  },
});

const toggleModal = () => showModal.value = !showModal.value;

const handleConfirm = async () => {
  toggleModal();

  try {
    await axios.post(`/ajax/website/${props.websiteId}/stop-cancellation`);

    Swal.fire({
      icon: 'success',
      title: 'Website cancellation stopped successfully',
      didClose: function() {
        window.location.reload();
      },
    });
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'Whoops',
      html: 'Could stop website cancellation, <br>please try again later.',
      didClose: function() {
        window.location.reload();
      },
    });
  }
}
</script>

<template>
  <div class="alert alert-warning d-flex align-items-end">
    <svg-vue
      class="svg svg-22 mr-2"
      icon="icons/warning-filled"
    />
    <div>
      <span>
        This website is due to be deleted on <strong>{{ endDate }}</strong>. To stop this website being deleted
        <span
          class="link pointer"
          @click="toggleModal"
        >
          click here
        </span>
      </span>
    </div>
    <StopWebsiteCancellationModal
      v-if="showModal"
      :end-date="endDate"
      @close="toggleModal"
      @confirm="handleConfirm"
    />
  </div>
</template>

<style scoped>
.svg-22 {
  max-width: 22px !important;
}

.link {
  color: #00C6DD;
}
</style>
